var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.4477 17.7439L26 24.2962L24.2962 26L17.7439 19.4477C16.5203 20.3282 15.0452 20.8656 13.4328 20.8656C9.32762 20.8656 6 17.538 6 13.4328C6 9.32762 9.32762 6 13.4328 6C17.538 6 20.8656 9.32762 20.8656 13.4328C20.8656 15.0452 20.3282 16.5203 19.4477 17.7439ZM13.4328 8.28702C10.5855 8.28702 8.28702 10.5855 8.28702 13.4328C8.28702 16.2802 10.5855 18.5786 13.4328 18.5786C16.2802 18.5786 18.5786 16.2802 18.5786 13.4328C18.5786 10.5855 16.2802 8.28702 13.4328 8.28702Z",
    fill: "#434343",
    fillOpacity: 0.5,
    stroke: "white",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.793fbf45477088c1b40e9c7c10e6a6db.svg";
export { ForwardRef as ReactComponent };